import React, { Fragment, useState, useContext, useEffect, Link } from 'react';
import {
    Paper,
    Grid,
    TextField,
    Select,
    MenuItem,
    Button,
    Typography,
    Dialog,
    DialogContent,
    InputAdornment,
    IconButton,
    Box
} from '@material-ui/core';
import { useStyles } from '../styles/CardStyles';
import 'date-fns';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';

const ActivateCardNominatePin = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const notificationContext = useContext(NotificationContext);
    const {
        userInfo,
        setUserInfo,
        errors,
        clearErrors,
        loading,
        CheckifSoftLock,
        getApplicationDetails,
        applicationDetails,
        requestForOTP,
        otp_succ,
        otpRequest,
        getVideoCallSchedule,
        videoCallSchedule,
        setVideoCallSchedule,
        setDisplayVideoCallSchedule,
        atmCardNumberDetails,
        atmCardDetailsBirthday,
        atmCardValidation,
        nominatePin,
        setNominatedPin,
        submitNominatedPin,
        setErrors,
        referenceCode,
    } = documentUploadContext;

    const [values, setValues] = useState({
        pin: '',
        showPIN: false
    });

    const [confirmPinValues, setConfirmPinValues] = useState({
        confirmPin: '',
        showConfirmPIN: false,
    });

    const [activationCodeValues, setactivationCodeValues] = useState({
        activationCode: ''
    });
    
    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value.replace(/[^0-9]/g, "") });
    };

    function allEqual(pin) {
        let n = pin.length;
        for (let i = 1; i < n; i++) {
            if (pin[i] != pin[0]) {
                return false;
            }
        }

        return true;
    }

    function birthdayEqual(pin) {
        
        let bmonth = atmCardDetailsBirthday.substr(0,2);
        let bdate = atmCardDetailsBirthday.substr(2,2);
        let byear = atmCardDetailsBirthday.substr(4,4);
       // const iMonth = 
        let tpin = pin.replace(bmonth,"");
        tpin = tpin.replace(bdate,"");
        tpin = tpin.replace(byear.substr(-2),"" );
       //pin.includes(bmonth) && pin.includes(bdate) && pin.includes(byear.substr(-2))
        if ( ( !tpin.length  ) ||
       ( pin.includes(bmonth) && pin.includes(byear) ) ||
       ( pin.includes(bdate) && pin.includes(byear) )
        )
        {
            return true;
        }

        return false;
    }
    
    function reverseString(lastHalf) {

        let newString = '';
        for (let i = lastHalf.length - 1; i >= 0; i--) {
            newString += lastHalf[i];
        }

        return newString
    }

    function checkSequence(pin) {
        
        var numbers = "01234567890123456";
        var numbersRev = "987654321098765";

       // return numbers.indexOf(String(pin)) === -1 && numbersRev.indexOf(String(pin)) === -1;    
        return !numbers.includes(String(pin))  && !numbersRev.includes(String(pin)) ;    
    }

    const [inlineErrorMessage, setInlineErrorMessage] = useState('');

    const handleConfirmPinChange = (prop) => (event) => {
        setConfirmPinValues({ ...confirmPinValues, [prop]: event.target.value.replace(/[^0-9]/g, "") });
    };
    
    const handleClickShowPIN = () => {
        setValues({ ...values, showPIN: !values.showPIN });
    };

    const handleClickShowConfirmPIN = () => {
        setConfirmPinValues({ ...confirmPinValues, showConfirmPIN: !confirmPinValues.showConfirmPIN });
    };
    
    const handleMouseDownPIN = (event) => {
        event.preventDefault();
    };

    const handleMouseDownConfirmPIN = (event) => {
        event.preventDefault();
    };

    const handleSubmitClick = (e) => {
        e.preventDefault();
        if (values.pin == '') {
            setInlineErrorMessage('Please nominate PIN.');
        }
        else
        {
            //console.log(atmCardValidation.mobileNumber);
            //otpRequest('09563869524');
            otpRequest(atmCardValidation.mobileNumber);
            nominatePin(values.pin);
            setOpen(true);
            //submitNominatedPin(atmCardNumberDetails, values.pin, confirmPinValues.confirmPin);       
            //submitNominatedPin('5363451780039058', values.pin, confirmPinValues.confirmPin);
            //submitNominatedPin('09563869524', values.otp, '5363451780039058', values.pin, confirmPinValues.confirmPin);       
        } 
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (errors != null) {
            notificationContext.setNotification(errors, 'error');
            clearErrors();
        }
    }, [userInfo, errors]);

    useEffect(() => {
        if (activationCodeValues.activationCode === ''){
            setactivationCodeValues(referenceCode);
        }
    },[referenceCode]);

    useEffect(() => {

        if (values.pin.length)
        {
            if (values.pin.length < 6)
            {
                setInlineErrorMessage('Please nominate a 6-digit PIN');
            }
            else if (atmCardNumberDetails.includes(values.pin)) 
            {
                setInlineErrorMessage('Please do not use a portion of your card number as PIN. Please nominate a valid PIN.');
            }
            else if (allEqual(values.pin)) 
            {
                setInlineErrorMessage('Please do not use repeating or consecutive numbers. Please nominate a valid PIN.');
            }
            else if (allEqual(values.pin.substring(0, 3))) 
            {
                setInlineErrorMessage('Please do not use repeating or consecutive numbers. Please nominate a valid PIN.');
            }
            else if (allEqual(values.pin.substring(values.pin.length - 3))) 
            {
                setInlineErrorMessage('Please do not use repeating or consecutive numbers. Please nominate a valid PIN.');
            }
            else if (values.pin.substring(0, 3) == values.pin.substring(values.pin.length - 3)) 
            {
                setInlineErrorMessage('Please do not use repeating or consecutive numbers. Please nominate a valid PIN.');
            }
            else if (values.pin.substring(0, 3) == reverseString(values.pin.substring(values.pin.length - 3))) 
            {
                setInlineErrorMessage('Please do not use repeating or consecutive numbers. Please nominate a valid PIN.');
            }
            else if (birthdayEqual(values.pin) == true)
            {
                setInlineErrorMessage('Birthdate not allowed as PIN. Please nominate a valid PIN.');
            }
            else if (checkSequence(values.pin) == false)
            {
                setInlineErrorMessage('PINs with repeating or consecutive numbers not allowed. Please nominate a valid PIN.');
            }
            else {
                setInlineErrorMessage('');
            }
        }
        else 
        {
            setInlineErrorMessage(' ');
        }
        
        if (confirmPinValues.confirmPin.length)
        {
            if (confirmPinValues.confirmPin != values.pin ) {
                setInlineErrorMessage('Nominated PIN and confirm PIN does not match.');
            }
        }  else {
            if (values.pin != ''){
            setInlineErrorMessage('Nominated PIN and confirm PIN does not match.');
        }
        }

    }, [values, confirmPinValues]);

    return (
        <div>
            <Header page={2} />
            <div className={classes.banner}>
            <Typography className={classes.paragraph}>
                Nominate a 6-digit PIN for your Flexi Card. For security purposes, never use your birthdate, other memorable dates, any number sequences printed on your Flexi Card, repeating (111111, 000000) or any sequential numbers (123456, 987654) as your PIN.
            </Typography>
                <Fragment>
                    <Paper elevation={0} className={classes.paper}>
                        
                        {loading ? (
                            <Spinner />
                        ) : (
                                <Fragment>
                                    <Grid container direction='row' spacing={3} justify="center">
                                        <Grid container md={4} item>
                                            <p classes={classes.txtFldLbl}>Nominate 6-Digit PIN</p>
                                            <TextField
                                                type={values.showPIN ? 'text' : 'password'}
                                                className={classes.txtField}
                                                value={values.pin}
                                                onChange={handleChange('pin')}
                                                variant='outlined'
                                                inputProps={{ maxLength: 6 , pattern: "[0-9]"}}
                                                InputProps={{
                                                    endAdornment: (
                                                    <InputAdornment>
                                                        <IconButton
                                                        style={{ color: '#0055A5' }}
                                                        onClick={handleClickShowPIN}
                                                        onMouseDown={handleMouseDownPIN}
                                                        >
                                                        {values.showPIN ? (
                                                            <Visibility />
                                                        ) : (
                                                            <VisibilityOff />
                                                        )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        <Grid container md={4} item>
                                            <p classes={classes.txtFldLbl}>Confirm 6-Digit PIN</p>
                                            <TextField
                                            type={confirmPinValues.showConfirmPIN ? 'text' : 'password'}
                                            className={classes.txtField}
                                            value={confirmPinValues.confirmPin}
                                            onChange={handleConfirmPinChange('confirmPin')}
                                            variant='outlined'
                                            inputProps={{ maxLength: 6, pattern: "[0-9]" }}
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment>
                                                    <IconButton
                                                    style={{ color: '#0055A5' }}
                                                    onClick={handleClickShowConfirmPIN}
                                                    onMouseDown={handleMouseDownConfirmPIN}
                                                    >
                                                    {confirmPinValues.showConfirmPIN ? (
                                                        <Visibility />
                                                    ) : (
                                                        <VisibilityOff />
                                                    )}
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid container direction='row' spacing={3} justify="center">
                                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                            <Button style={{ textAlign: 'right' }} 
                                            className={classes.button} 
                                            variant='contained' 
                                            color='primary' 
                                            type='submit' 
                                            onClick={handleSubmitClick}
                                            disabled={inlineErrorMessage.length}    
                                            >Proceed</Button>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid container direction='row' spacing={3} justify="center">
                                    </Grid>
                            <Grid container direction='row' spacing={3} >
                                     <div className={classes.inlineErrorMessage} >{inlineErrorMessage}</div>   
                                     
                            </Grid>
                                </Fragment>
                            )}
                            <Notification />
                    </Paper>
                    <Dialog aria-labelledby='customized-dialog-title' open={open}>
                        <DialogContent dividers>
                            <OTP handleClose={handleClose} />
                        </DialogContent>
                    </Dialog>
                </Fragment>
            </div>
        </div>
    );
};

export default ActivateCardNominatePin;
